import { Component, OnInit } from '@angular/core';
import { trigger, style, animate, transition, query, stagger } from '@angular/animations';
import { CommonModule, NgClass } from '@angular/common';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-verification-dashboard',
  standalone: true,
  imports: [CommonModule, RouterModule,FormsModule],
  templateUrl: './verification-dashboard.component.html',
  styleUrls: ['./verification-dashboard.component.css'],
})


export class VerificationDashboardComponent {

  steps = [
    { text: 'Create a payment processor account.' },
    { text: 'Use the mobile payment system to checkout.' },
    { text: 'Move funds from various payment platforms.' },
    { text: 'Start building your credit record.' },
    { text: 'Create a business account on Amazon.' },
    { text: 'Receive cash in US dollars from users globally.' },
    { text: 'Pay with a credit card.' },
    { text: 'Send wires both domestically and internationally.' },
    { text: 'Inbound domestic and international wires are received.' },
    { text: 'Prevent online fraud with multi-layered security.' }
  ];

}
